/** DOMPurify options for agreement HTML — shared by editor, preview, signing, and character limit checks. */
export const AGREEMENT_EDITOR_PURIFY_OPTIONS = {
  ALLOWED_TAGS: [
    'p',
    'br',
    'hr',
    'span',
    'strong',
    'b',
    'em',
    'i',
    'u',
    's',
    'strike',
    'ul',
    'ol',
    'li',
    'blockquote',
    'h1',
    'h2',
    'h3',
    'h4',
    'div',
    'img',
    'a',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
    'colgroup',
    'col',
    'pre',
  ],
  ALLOWED_ATTR: ['style', 'class', 'data-font-size', 'data-font-family', 'src', 'alt', 'width', 'height', 'href', 'colspan', 'rowspan'],
}

/** Recipient bracket signing: same as editor plus inline input tags for placeholders. */
export const AGREEMENT_SIGNING_BRACKET_PURIFY_OPTIONS = {
  ALLOWED_TAGS: [...AGREEMENT_EDITOR_PURIFY_OPTIONS.ALLOWED_TAGS, 'input'],
  ALLOWED_ATTR: [
    ...AGREEMENT_EDITOR_PURIFY_OPTIONS.ALLOWED_ATTR,
    'type',
    'data-bf-slot',
    'placeholder',
    'aria-label',
    'aria-invalid',
    'autocomplete',
    'name',
  ],
}
